<template>
    <el-dialog  class="work-edit" :title="isCreate?'添加工作':'修改工作'" :visible.sync="visible" @open="initData" @closed="onCloseAction" :destroy-on-close="true" width="800px">
        <el-form :model="form" :rules="rules" ref="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="职位" prop="name">
                <el-input size="mini" v-model="form.name" autocomplete="off" placeholder="职位名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型" prop="type">
                <el-input size="mini" v-model="form.type" autocomplete="off" placeholder="职位类型"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="工作年限，底线" prop="experience_base">
                <el-input size="mini" v-model.number="form.experience_base" autocomplete="off" placeholder="薪酬底线"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作年限，顶线" prop="experience_height">
                <el-input size="mini" v-model.number="form.experience_height" autocomplete="off" placeholder="薪酬顶线"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="薪酬底线(单位:k)" prop="salary_base">
                <el-input size="mini" v-model.number="form.salary_base" autocomplete="off" placeholder="薪酬底线"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="薪酬顶线(单位:k)" prop="salary_height">
                <el-input size="mini" v-model.number="form.salary_height" autocomplete="off" placeholder="薪酬顶线"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item   label="学历要求" prop="education_requirement">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-select  v-model="form.education_requirement" size="mini">
                      <el-option  :label="x.label" :value="x.value" :key="x.value" v-for="x in [{label:'无限制',value:0},{label:'大专',value:1},{label:'本科',value:2},{label:'本科及以上',value:3}]"></el-option>
                    </el-select>
                  </el-col>

                </el-row>
<!--                <el-input size="mini" v-model="form.education_requirement" autocomplete="off" placeholder="学历要求"></el-input>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作地点" prop="address">
                <el-input size="mini" v-model="form.address" autocomplete="off" placeholder="工作地点"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="技能要求">
                <el-select size="mini" v-model="skillForm" multiple collapse-tags filterable default-first-option @change="onSelectedSkill($event)" placeholder="工作技能">
                  <el-option v-for="item in skillOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-input size="mini" class="input-new-tag" v-if="inputSkillVisible" v-model="inputSkillValue" ref="saveSkillTagInput" @keyup.enter.native="handleInputSkillConfirm" @blur="handleInputSkillConfirm">
                </el-input>
                <el-button size="mini" class="button-new-tag" @click="showSkillInput">+ 添加工作技能</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="福利待遇">
                <el-select size="mini" v-model="benefitForm" multiple collapse-tags filterable default-first-option style="margin-left: 20px;" placeholder="请选择" @change="onSelectBenefots($event)">
                  <el-option v-for="item in benefitOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-input size="mini" class="input-new-tag" v-if="inputBenefitVisible" v-model="inputBenefitValue" ref="saveBenefitTagInput" @keyup.enter.native="handleInputBenefitConfirm" @blur="handleInputBenefitConfirm">
                </el-input>
                <el-button size="mini" class="button-new-tag" @click="showBenefitInput">+ 添加福利待遇</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="职位详情" prop="describe">
            <el-input size="mini" v-model="form.describe" :autosize="{minRows:4,maxRows:6}" show-word-limit :maxlength="300" type="textarea" autocomplete="off" placeholder="职位详情" />
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-button size="mini" type="primary" @click="handleSubmit" class="d2-fr">-->
<!--              提交-->
<!--            </el-button>-->
<!--          </el-form-item>-->
        </el-form>
        <div slot="footer" >
          <el-button size="medium" type="info" @click="onCloseAction">取消</el-button>
          <axj-button color="#00adb5"  size="max" @click="handleSubmit">保存</axj-button>
        </div>
    </el-dialog>
</template>
<script>
import { fetchServiceWorkOfferSkillRelationList, createServiceWorkOfferSkillRelation, deleteServiceWorkOfferSkillRelation,fetchServiceWorkOfferSkillList, createServiceWorkOfferSkill, fetchServiceWorkOfferBenefitRelationList, createServiceWorkOfferBenefitRelation, deleteServiceWorkOfferBenefitRelation,createServiceWorkOffer, updateServiceWorkOffer, fetchServiceWorkOfferBenefitList, createServiceWorkOfferBenefit } from "@/api/axj-service/axj-service-work"
// import { formatTime } from '@/plugin/filter'
import { mapState } from 'vuex'
export default {
  name: "work-edit",
  props: {
    id: {
      type: Number,
      default: 0
    },
    isCreate: {
      type: Boolean,
      default: true,
    },
    sourceForm: {
      type: Object,
      default: () => ({})
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      form: {
        name: '',
        describe: '',
        type: '',
        salary_base: undefined,
        salary_height: undefined,
        education_requirement: '',
        experience_base: undefined,
        experience_height: undefined,
        skill_requirement: '',
        address: '',
      },
      // 工作技能
      skillOption: [],
      skillForm: [],
      inputSkillValue: '',
      // 工作福利
      benefitOption: [],
      benefitForm: [],
      inputBenefitValue: '',
      //
      inputSkillVisible: false,
      inputBenefitVisible: false,
      rules: {
        name: [
          { required: true, message: '职位名称不能为空', trigger: 'change' }
        ],
        type: [
          { required: true, message: '职位类型不能为空', trigger: 'change' }
        ],
        experience_base: [
          { required: true, message: '请输入工作最低年限（门槛）', trigger: 'change' }
        ],
        experience_height: [
          { required: true, message: '请输入工作最高年限（门槛）', trigger: 'change' }
        ],
        salary_base: [
          { required: true, message: '请输入最低薪水', trigger: 'change' }
        ],
        salary_height: [
          { required: true, message: '请输入目前最高薪水', trigger: 'change' }
        ],
        education_requirement: [
          { required: true, message: '请输入学历要求', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入工作地点', trigger: 'change' }
        ],
        describe: [
          { required: true, message: '请输入职位详情', trigger: 'change' }
        ],
      },
    }
  },
  methods: {
    deStoreData(){
      this.form={
        name: '',
          describe: '',
          type: '',
          salary_base: undefined,
          salary_height: undefined,
          education_requirement: '',
          experience_base: undefined,
          experience_height: undefined,
          skill_requirement: '',
          address: '',
      }
      // 工作技能
      this.skillOption= []
      this.skillForm=[]
      this.inputSkillValue=''
        // 工作福利
      this.benefitOption=[]
      this.benefitForm=[]
      this.inputBenefitValue=''
      this.inputSkillVisible=false
      this.inputBenefitVisible=false
    },
    initData() {
      this.initSkillOption()
      this.initBenefitOption()
    },
    initSkillOption() {
      fetchServiceWorkOfferSkillList()
        .then(res=> {
          this.skillOption = res.data.lists.map(item => {
            return { value: item.id, label: item.name };
          })
        })
        .catch(err => {
          console.log("init benefit error")
        })
    },
    initBenefitOption() {
      fetchServiceWorkOfferBenefitList()
        .then(res=> {
          this.benefitOption = res.data.lists.map(item => {
            return { value: item.id, label: item.name };
          })
        })
        .catch(err => {
          console.log("init skill error")
        })
    },
    onCloseAction() {
      this.deStoreData()
      this.$emit('update:show', false)
    },
    success(){
      this.deStoreData()
      this.$emit('update:show', false)
      this.$emit('editSuccess')
    },
    handleSubmit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // this.id 为 书籍的 id，书评是评论书籍的
          if (this.isCreate) {
            if (this.id) {
              // 有 id
              this.form.company_id = this.id
              this.form.user_id = this.info.id
              this.form.user_name = this.info.nickname
              this.form.user_avatar = this.info.avatar
              this.form.status = 1
              await this.handleCreateServiceWorkOffer(this.form)
            } else {
              this.$notify.error({
                message: '发布失败，请重试（未检测到company_id）',
                type: 'danger',
                duration: 2000
              })
            }
          } else {
            // 删除关联
            this.deleteOfferRelation(this.form.id)
            // 去除杂质
            //4000-600=3400
            this.$delete(this.form, 'created_at')
            this.$delete(this.form, 'updated_at')
            this.$delete(this.form, 'Count')
            this.$delete(this.form, 'Company')
            this.$delete(this.form, 'BenefitRelation')
            this.$delete(this.form, 'SkillRelation')
            this.$delete(this.form, 'BenefitRelation')
            this.handleUpdateServiceWorkOffer(this.form)
          }
          this.success()
        }
      })
      console.log(this.form)
    },
    handleCreateServiceWorkOffer(form) {
      return new Promise((resolve,reject)=>{
        createServiceWorkOffer(form)
          .then(res=> {
            this.$notify({
              message: '工作职位发布成功',
              type: 'success',
              duration: 2000
            })
            this.createOfferRelation(res.data.id)
            resolve('success')
          })
          .catch(err => {
            this.$notify.error({
              message: '工作职位发布失败，请重试',
              type: 'danger',
              duration: 2000
            })
            console.log(err)
          })
      })
    },
    handleUpdateServiceWorkOffer(form) {
      updateServiceWorkOffer(form)
        .then(res=> {
          this.$notify({
            message: '工作职位修改成功',
            type: 'success',
            duration: 2000
          })
          this.createOfferRelation(form.id)
        })
        .catch(err => {
          this.$notify.error({
            message: '工作职位修改失败，请重试',
            type: 'danger',
            duration: 2000
          })
          console.log(err)
        })
    },
    createOfferRelation(id) {
      for (var i = 0; i < this.skillForm.length; i++) {
        createServiceWorkOfferSkillRelation({
          offer_id: id,
          skill_id: this.skillForm[i]
        })
          .then(res=> {
            this.$notify({
              message: '创建技能关联成功',
              type: 'success',
              duration: 2000
            })
          })
          .catch(err => {
            this.$notify.error({
              message: '创建技能关联成功，请重试',
              type: 'danger',
              duration: 2000
            })
          })
      }
      for (var j = 0; j < this.benefitForm.length; j++) {
        createServiceWorkOfferBenefitRelation({
          offer_id: id,
          benefit_id: this.benefitForm[j]
        })
          .then(res=> {
            this.$notify({
              message: '创建福利关联成功',
              type: 'success',
              duration: 2000
            })
          })
          .catch(err => {
            this.$notify.error({
              message: '创建福利关联成功，请重试',
              type: 'danger',
              duration: 2000
            })
          })
      }
      this.$emit("create-successful")
    },
    deleteOfferRelation(id) {
      this.deleteOfferBenefitRelation(id)
      this.deleteOfferSkillRelation(id)
    },
    deleteOfferBenefitRelation(id) {
      fetchServiceWorkOfferBenefitRelationList({
        where: JSON.stringify({
          offer_id: id
        })
      })
        .then(res=> {
          for (var i = 0; i < res.lists.length; i++) {
            deleteServiceWorkOfferBenefitRelation(res.lists[i].id)
              .then(res=> {
                console.log("delete Benefit", res)
              })
          }
        })
    },
    deleteOfferSkillRelation(id) {
      fetchServiceWorkOfferSkillRelationList({
        where: JSON.stringify({
          offer_id: id
        })
      })
        .then(res=> {
          for (var i = 0; i < res.lists.length; i++) {
            deleteServiceWorkOfferSkillRelation(res.lists[i].id)
              .then(res=> {
                console.log("delete Skill", res)
              })
          }
        })
    },
    handleUpdateBookArticle(form) {
      updateReadclubArticle(form)
        .then(res=> {
          this.$notify({
            message: '工作职位修改成功',
            type: 'success',
            duration: 2000
          })
          this.onCloseAction()
        })
        .catch(err => {
          this.$notify.error({
            message: '工作职位修改失败，请重试',
            type: 'danger',
            duration: 2000
          })
          console.log(err)
        })
    },
    showSkillInput() {
      this.inputSkillVisible = true
      this.$nextTick(_ => {
        this.$refs.saveSkillTagInput.$refs.input.focus()
      });
    },
    showBenefitInput() {
      this.inputBenefitVisible = true
      this.$nextTick(_ => {
        this.$refs.saveBenefitTagInput.$refs.input.focus()
      });
    },
    // 选择技能
    onSelectedSkill(event) {
      console.log(event)
      this.skillForm = event
    },
    // 选择福利
    onSelectBenefots(event) {
      console.log(event)
      this.benefitForm = event
    },
    handleInputSkillConfirm() {
      let inputSkillValue = this.inputSkillValue;
      if (inputSkillValue) {
        let skill = {
          name: inputSkillValue
        }
        createServiceWorkOfferSkill(skill)
          .then(res=> {
            this.$notify({
              message: '工作技能添加成功',
              type: 'success',
              duration: 2000
            })
            console.log(res)
            this.inputSkillVisible = false
            this.inputSkillValue = ''
            this.initSkillOption()
          })
      }
    },
    handleInputBenefitConfirm() {
      let inputBenefitValue = this.inputBenefitValue;
      if (inputBenefitValue) {
        let workBenefitsPost = {
          name: inputBenefitValue
        }
        createServiceWorkOfferBenefit(workBenefitsPost)
          .then(res=> {
            this.$notify({
              message: '工作福利添加成功',
              type: 'success',
              duration: 2000
            })
            console.log(res)
            this.inputBenefitVisible = false
            this.inputBenefitValue = ''
            this.initBenefitOption()
          })
      }
    },
  },

  watch: {
    show() {
      this.visible = this.show
    },
    sourceForm() {
      this.form = this.sourceForm
      if (this.sourceForm.SkillRelation) {
        this.skillForm = this.sourceForm.SkillRelation.map(item => {
          return item.id
        })
      }
      if (this.sourceForm.BenefitRelation) {
        this.benefitForm = this.sourceForm.BenefitRelation.map(item => {
          return item.id
        })
      }
    }
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
}

</script>
<style lang="scss">
.work-edit {
  .el-card__header {
    padding: 5px 20px;
    border-bottom: 0px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-card__body {
    padding: 5px 20px;
  }

  .el-dialog__body {
    padding: 5px auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/work-edit/index.vue